export const ExamType = {
    MAIN_EXAM: 0,
    REPEAT_EXAM: 1, 
    FIRST_REPEAT_EXAM: 2,
    SECOND_REPEAT_EXAM: 3,
    ENTRANCE_EXAM: 20
};

export const ExamTypeLabel = {
    [ExamType.MAIN_EXAM]: 'Thi chính',
    [ExamType.REPEAT_EXAM]: 'Thi lại',
    [ExamType.FIRST_REPEAT_EXAM]: 'Thi thử lần 1',
    [ExamType.SECOND_REPEAT_EXAM]: 'Thi thử lần 2',
    [ExamType.ENTRANCE_EXAM]: 'Thi đầu khóa'
};

export function getExamTypeLabel(type) {
    return ExamTypeLabel[type] || '';
} 